import React from 'react';

import Select from '../Select';

const data = [{
    value: 2,
    label: "不启用"
}, {
    value: 1,
    label: "启用"
}];

const IsEnable = (props) => (
    <Select name="isEnable" label="是否启用" data={data} {...props} ></Select>
);

export default IsEnable;